<template>
  <div>
    <el-row :gutter="20">
      <el-col v-for="(org,index) in saleOrgs" :span="6">
        <el-card shadow="hover" :class="pickedArray[index] === true ? 'picked_border' : 'unpicked_border'">
        <el-form :model="org" label-width="160px">
          <el-form-item label="公司名称" prop="name">
            <el-input v-model="org.name" disabled></el-input>
          </el-form-item>
          <el-form-item label="公司编码" prop="number">
            <el-input v-model="org.number" disabled></el-input>
          </el-form-item>
          <el-form-item label="登录用户名">
            <el-input v-model="currentUser.username" disabled></el-input>
          </el-form-item>
          <el-form-item label="当前公司">
            <el-switch  v-model="pickedArray[index]" @change="pick(index)" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
          </el-form-item>
        </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import {mapMutations} from "vuex";

export default {
  data(){
    return{
      pickedIndex:0,
      pickedArray:[]
    }
  },
  computed: {
    ...mapGetters(["currentUser"]),
    ...mapGetters(["saleOrgs"]),
    ...mapMutations(['SET_S_INDEX'])
  },
  mounted() {
    this.pickedIndex = 0;
    for(let org in this.saleOrgs){
      if(this.pickedArray.length == 0){
        this.pickedArray.push(true);
      }
      this.pickedArray.push(false);
    }
  },
  methods:{
    pick(index){
      this.pickedArray[this.pickedIndex] = false;
      this.pickedIndex = index;
      this.pickedArray[this.pickedIndex] = true;
      this.$store.commit('SET_S_INDEX' , index);
    }
  }
}
</script>

<style scoped>
.picked_border{
  border-color: #13ce66;
  border-width: 2px;
  border-radius: 20px;
}
.unpicked_border{

}
</style>
